import { Check } from "lucide-react";

export interface WizardStep {
  label: string;
  title: string;
}

interface StepIndicatorProps {
  steps: WizardStep[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="bg-white border border-[#E4E4E7] rounded-[8px] px-[24px] py-[20px] flex items-center">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;

        return (
          <div key={step.label} className="flex items-center flex-1 last:flex-none">
            <div className="flex items-center gap-[10px]">
              <div
                className={`flex items-center justify-center size-[28px] rounded-full text-[13px] font-semibold shrink-0 ${
                  isCompleted
                    ? "bg-[#16A34A] text-white"
                    : isCurrent
                      ? "bg-[#734792] text-white"
                      : "bg-white border border-[#E4E4E7] text-[#A1A1AA]"
                }`}
              >
                {isCompleted ? <Check className="size-[14px]" /> : stepNumber}
              </div>
              <div className="hidden sm:block">
                <p
                  className={`text-[11px] font-semibold tracking-wide uppercase ${
                    isCompleted || isCurrent ? "text-[#734792]" : "text-[#A1A1AA]"
                  }`}
                >
                  Step {stepNumber}
                </p>
                <p
                  className={`text-[13px] font-medium ${
                    isCompleted || isCurrent ? "text-[#1E1E1E]" : "text-[#A1A1AA]"
                  }`}
                >
                  {step.title}
                </p>
              </div>
            </div>
            {stepNumber < steps.length && (
              <div
                className={`h-[2px] flex-1 mx-[16px] ${
                  isCompleted ? "bg-[#16A34A]" : "bg-[#E4E4E7]"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
